import { TvvBesteldeRouteActieDto } from "@/shared/types";
import { parseISO } from "date-fns";
import { BaseActie } from "./base-actie";

export type TvvRouteBesteldActie = BaseActie & {
    type: "TvvBesteldeRoute";
    besteldeRouteId?: number | undefined;
};

export const TvvRouteBesteldActie = {
    fromDto(dto: TvvBesteldeRouteActieDto): TvvRouteBesteldActie {
        return {
            id: dto.id,
            type: "TvvBesteldeRoute",
            timelineContent: {
                titel: "TVV aangevraagd",
                beschrijving: "De regievoerder heeft een of meer TVV routes aangevraagd",
                actieTekst: "Bekijk openstaande aanvragen",
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: dto.wijzigingType,
            besteldeRouteId: dto.besteldeRouteId,
        };
    },
};

export type TvvStopBesteldeRouteActie = BaseActie & {
    type: "TvvStopBesteldeRoute";
    besteldeRouteId?: number | undefined;
};

export const TvvStopBesteldeRouteActie = {
    fromDto(dto: TvvBesteldeRouteActieDto): TvvStopBesteldeRouteActie {
        return {
            id: dto.id,
            type: "TvvStopBesteldeRoute",
            timelineContent: {
                titel: "Stop TVV aangevraagd",
                beschrijving: "De regievoerder verzoekt een of meerdere TVV routes te stoppen",
                actieTekst: "Bekijk openstaande aanvragen",
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: dto.wijzigingType,
            besteldeRouteId: dto.besteldeRouteId,
        };
    },
};

export type TvvWijzigBesteldeRouteActie = BaseActie & {
    type: "TvvWijzigBesteldeRoute";
    besteldeRouteId?: number | undefined;
};

export const TvvWijzigBesteldeRouteActie = {
    fromDto(dto: TvvBesteldeRouteActieDto): TvvWijzigBesteldeRouteActie {
        return {
            id: dto.id,
            type: "TvvWijzigBesteldeRoute",
            timelineContent: {
                titel: "Wijziging TVV aangevraagd",
                beschrijving: "De regievoerder heeft de aanvraag voor een TVV route gewijzigd",
                actieTekst: "Bekijk openstaande aanvragen",
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: dto.wijzigingType,
            besteldeRouteId: dto.besteldeRouteId,
        };
    },
};

export type TvvAfschalingBesteldeRouteActie = BaseActie & {
    type: "TvvAfschalingBesteldeRoute";
    besteldeRouteId?: number | undefined;
};

export const TvvAfschalingBesteldeRouteActie = {
    fromDto(dto: TvvBesteldeRouteActieDto): TvvAfschalingBesteldeRouteActie {
        return {
            id: dto.id,
            type: "TvvAfschalingBesteldeRoute",
            timelineContent: {
                titel: "Afschaling TVV aangevraagd",
                beschrijving: "De regievoerder heeft een afschaling van het aantal bussen voor een TVV route gewijzigd",
                actieTekst: "Bekijk openstaande aanvragen",
            },
            verstuurdOpDatumTijd: parseISO(dto.verstuurdOpDatumTijd),
            status: dto.status,
            wijzigingType: dto.wijzigingType,
            besteldeRouteId: dto.besteldeRouteId,
        };
    },
};

export type TvvActie = TvvRouteBesteldActie | TvvWijzigBesteldeRouteActie | TvvStopBesteldeRouteActie | TvvAfschalingBesteldeRouteActie;
